import React, { useState } from 'react';
import IconeNotificacao from './IconeNotificacao';
import PainelNotificacoes from './PainelNotificacoes';
import { useNotificacoes } from '../../hooks/useNotificacoes';
import { Box } from '@mui/material';

const Notificacoes: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const { totalNaoLidas } = useNotificacoes({
    carregarAutomaticamente: true,
    apenasNaoLidas: true,
    intervaloAtualizacao: 30000, // Atualiza a cada 30 segundos
  });

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box 
      sx={{ 
        display: 'flex', 
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        padding: '0 12px',
        position: 'relative'
      }}
      className="notification-container"
    >
      <IconeNotificacao 
        contador={totalNaoLidas} 
        onClick={handleClick} 
      />
      <PainelNotificacoes 
        anchorEl={anchorEl} 
        onClose={handleClose} 
      />
    </Box>
  );
};

export default Notificacoes; 